export default __webpack_public_path__ + "static/media/exclamation-circle.6a4e617e.svg";